import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Stack from 'components/Stack';
import Button from 'components/Button';
import { useFetchComments } from 'actions/comments';
import CommentWrapper from './CommentWrapper';
import Comment from './Comment';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Replies(_ref) {
  var contentId = _ref.contentId,
    comment = _ref.comment,
    user = _ref.user,
    size = _ref.size;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var _useFetchComments = useFetchComments({
      contentId: contentId,
      parentId: comment.id,
      limit: 5
    }),
    replies = _useFetchComments.items,
    hasNextPage = _useFetchComments.hasNextPage,
    fetchNextPage = _useFetchComments.fetchNextPage,
    areRepliesLoading = _useFetchComments.isLoading;
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: "xs",
    pt: "xs",
    children: [replies === null || replies === void 0 ? void 0 : replies.map(function (reply) {
      var _reply$author;
      var isUserComment = (reply === null || reply === void 0 || (_reply$author = reply.author) === null || _reply$author === void 0 ? void 0 : _reply$author.id) === (user === null || user === void 0 ? void 0 : user.id);
      return reply && /*#__PURE__*/_jsx(CommentWrapper, {
        comment: reply,
        isUserComment: isUserComment,
        children: /*#__PURE__*/_jsx(Comment, {
          comment: reply,
          isUserComment: isUserComment,
          isNested: true,
          size: size
        })
      }, reply === null || reply === void 0 ? void 0 : reply.id);
    }), hasNextPage && fetchNextPage && /*#__PURE__*/_jsx(Box, {
      pl: 76,
      children: /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          return fetchNextPage();
        },
        isDisabled: areRepliesLoading,
        size: "small",
        children: t('comments_more_replies')
      })
    })]
  });
}
export default Replies;